export const PATH_APP = {
  root: '/',
  room: '/room',
  booking: '/booking',
};
